export default "__VITE_ASSET__Tl5eTsTH__"